<template>
  <v-card hover color="white" class="card-bg" @click="() => click()">
    <v-card-title style="padding-bottom: 0" v-if="title" class="card-title">
      {{ title }}
    </v-card-title>
    <v-container style="padding-top: 0; padding-bottom: 0">
      <slot></slot>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: 'GenericIndex',
  props: {
    title: {
      required: false,
      type: String
    },
    click: {
      type: Function,
    }
  }
}
</script>

<style scoped>
.card-bg {
  border-radius: 11px !important;
  width: 90vw;
}

.card-title {
  font-family: Open Sans;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  word-break: keep-all;
  line-height: 27px;
  color: var(--v-primary);
}
</style>